module.exports = __webpack_public_path__ + "img/numbersAnalytics.6ca6534a.png";